export class MetadataMap {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadataByType = new Map();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    getMetadataByType(classType) {
        return this.metadataByType.get(classType) || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setMetadataByType(classType, keyName, metadata) {
        this.metadataByType.set(classType, Object.assign({}, this.getMetadataByType(classType), {
            [keyName]: metadata,
        }));
    }
}
